var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-container",style:({ minWidth: (_vm.minWidth + "px"), minHeight: (_vm.minHeight + "px") })},[_c('svg-icon',{staticClass:"loading-container__icon-body",attrs:{"name":"Spin"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }